import * as React from 'react';

import { get as userGet } from 'js/lib/user';

import { Grid } from '@coursera/cds-core';

import { useDegreeMyPageHeader } from 'bundles/composable-page-header-degree/contexts/DegreeMyPageHeaderContext';
import MainNavigationWrapper from 'bundles/composable-page-header/components/MainNavigationWrapper';
import LanguageDropdownLegacyGridItem from 'bundles/composable-page-header/components/grid-items/LanguageDropdownLegacyGridItem';
import NotificationsLegacyGridItem from 'bundles/composable-page-header/components/grid-items/NotificationsLegacyGridItem';
import ProgramSwitcherGridItem from 'bundles/composable-page-header/components/grid-items/ProgramSwitcherGridItem';
import UnauthenticatedActionsGridItem from 'bundles/composable-page-header/components/grid-items/UnauthenticatedActionsGridItem';
import CoachStudioGridItem, {
  showCoachStudio,
} from 'bundles/composable-page-header/components/grid-items/coach/CoachStudioGridItem';
import DefaultLogoImage from 'bundles/composable-page-header/components/grid-items/home-logo/DefaultLogoImage';
import HomeLogoGridItemModule from 'bundles/composable-page-header/components/grid-items/home-logo/HomeLogoGridItemModule';
import { logInButtonProps } from 'bundles/composable-page-header/constants';
import DefaultAccountDropdownGridItemRenderer from 'bundles/composable-page-header/module-renderers/DefaultAccountDropdownGridItemRenderer';
import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

import _t from 'i18n!nls/composable-page-header-degree';

const DegreeDesktopMainNav = () => {
  const {
    chosenEnterpriseProgram,
    enrolledDegreePrograms,
    enrolledEnterprisePrograms,
    chosenDegree,
    hasEnrolledPrograms,
    naptimeManagedThirdPartyOrganizations,
    hasCheatingIncidents,
    canViewEducatorAdminLink,
    isCourseraPlusLearner,
    courseraPlusSubscriptionCycle,
    naptimeChosenOrganization,
    naptimeOrganizationsWithProgramEnrollments,
  } = useDegreeMyPageHeader();

  const isLoggedIn = !!userGet()?.id;
  const isOrgScoped = GrowthDiscoveryEpicClient.preview('orgScopedHome');

  return (
    <MainNavigationWrapper>
      <Grid item md={8} lg={7} container alignItems="center" spacing={16}>
        {isLoggedIn && !isOrgScoped && (
          <Grid item>
            <ProgramSwitcherGridItem
              currentProgram={chosenEnterpriseProgram}
              currentDegree={chosenDegree}
              programs={enrolledEnterprisePrograms}
              degrees={enrolledDegreePrograms}
            />
          </Grid>
        )}
        <Grid item>
          <HomeLogoGridItemModule
            href={`/degrees/${chosenDegree?.slug}/home`}
            ariaLabel={_t('#{degreeName} home page | Coursera', { degreeName: chosenDegree?.name || 'Degree' })}
            logos={[
              <DefaultLogoImage
                key={`${chosenDegree?.partners[0]?.id || 0}_header_logo_image`}
                src={chosenDegree?.partners[0]?.rectangularLogo || ''}
                alt={chosenDegree?.partners[0]?.name || ''}
              />,
            ]}
          />
        </Grid>
      </Grid>
      <Grid item container md={4} lg={5} justifyContent="flex-end" alignItems="center">
        {isLoggedIn && (
          <React.Fragment>
            {!isOrgScoped && <LanguageDropdownLegacyGridItem currentThirdPartyOrgId={chosenDegree?.id} />}
            <Grid item>
              <NotificationsLegacyGridItem />
            </Grid>
          </React.Fragment>
        )}
        {isLoggedIn && showCoachStudio() && (
          <Grid item>
            <CoachStudioGridItem />
          </Grid>
        )}
        <Grid item>
          {isLoggedIn ? (
            <DefaultAccountDropdownGridItemRenderer
              hasEnrolledPrograms={!!hasEnrolledPrograms}
              naptimeManagedThirdPartyOrganizations={naptimeManagedThirdPartyOrganizations}
              hasCheatingIncidents={!!hasCheatingIncidents}
              canViewEducatorAdminLink={!!canViewEducatorAdminLink}
              isCourseraPlusLearner={!!isCourseraPlusLearner}
              courseraPlusSubscriptionCycle={courseraPlusSubscriptionCycle}
              currentOrganization={naptimeChosenOrganization}
              organizations={naptimeOrganizationsWithProgramEnrollments}
              degrees={enrolledDegreePrograms}
              currentDegree={chosenDegree}
            />
          ) : (
            <UnauthenticatedActionsGridItem buttons={[logInButtonProps()]} />
          )}
        </Grid>
      </Grid>
    </MainNavigationWrapper>
  );
};

export default DegreeDesktopMainNav;
